var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.009 9.34154V12.8943M12.009 16.4471H12.018M20.759 17.3353L13.5648 4.90054C13.4079 4.62716 13.1804 4.39976 12.9055 4.24156C12.6306 4.08335 12.3182 4 12 4C11.6819 4 11.3694 4.08335 11.0945 4.24156C10.8196 4.39976 10.5921 4.62716 10.4353 4.90054L3.241 17.3353C3.08244 17.6066 2.9993 17.9144 3 18.2275C3.00071 18.5407 3.08523 18.8482 3.245 19.1187C3.40478 19.3892 3.63412 19.6132 3.9098 19.768C4.18547 19.9227 4.49767 20.0027 4.81475 19.9999H19.2033C19.5188 19.9996 19.8288 19.9173 20.1019 19.7613C20.3751 19.6052 20.6019 19.3809 20.7595 19.1109C20.9171 18.8409 21.0001 18.5347 21 18.2231C20.9999 17.9114 20.9168 17.6052 20.759 17.3353Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.3e098a29368117dd77c063f512169e85.svg";